import { generalAPI } from "../../services/firebase-api/firebase-api";


export const getAndDispatchUser = async (userId, dispatch, action) => {

  let searchingUser = await generalAPI.getDoc('users', 'userId', userId);
  if (searchingUser) {

    dispatch(action(searchingUser, true))

  } else {
    dispatch(action(null, false))
  }

}

export const getFirebaseError = (error) => {
  let message = 'Something Wrong with Registration Data'
  if (error.code === 'auth/email-already-in-use') {

    message = 'User is Already Exist! Please, Sign In!'
  }
  return {
    resultCode: 1,
    data: null,
    message
  }
}